import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import iconDocTpl from "../../../../assets/templateV2/doc_tpl.svg";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors } from "../../../../components/theme";

const defaultOptionsMenu = [
  /*	{
		label: "Shipping",
		value: "Shipping",
		icon: <LocalShippingIcon />,
	},*/
  {
    label: "Send",
    value: "Send",
    icon: <CloudUploadIcon />,
  },
  {
    label: "Rename",
    value: "Rename",
    icon: <BorderColorIcon />,
  },
  {
    label: "Edit Template",
    value: "EditTemplate",
    icon: <EditIcon />,
  },
  {
    label: "Archive",
    value: "Delete",
    icon: <DeleteIcon />,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: 100,
    height: 110,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: "15px 10px 0 10px",
    boxSizing: "border-box",
    borderRadius: "5px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#eef5fb",
      backgroundImage:
        "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23199CE3FF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
    },
  },
  icon: {
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  title: {
    width: "100%",
    fontSize: 11,
    fontWeight: "normal",
    textAlign: "center",
    color: "#000000",
    marginTop: "0px",
    wordBreak: "break-word",
    lineHeight: 1,
    padding: "0px 5px 2px 5px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: "24px",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    maxWidth: "100px",
  },
  moreIconBtn: {
    width: "auto",
    height: "auto",
    position: "absolute",
    top: 5,
    right: 5,
    padding: 0,
    zIndex: 100,
  },
  menu: {
    backgroundColor: "#fff",
    borderWidth: 0,
    borderColor: "transparent",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
  },
  menuItemText: {
    marginLeft: "10px",
    color: "#0D0D0D",
  },
  iconFile: {
    width: 56,
    height: 70,
  },
}));

export default function TemplateCard({
  template,
  onClickMenu,
  optionsMenu = defaultOptionsMenu,
  docIcon = iconDocTpl,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const fullName = template?.templateName || "";

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (menu, template) => {
    console.log("menu", menu);
    setAnchorEl(null);
    onClickMenu(menu, template);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={classes.root} variant="outlined" title={fullName}>
      <IconButton
        className={classes.moreIconBtn}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleMenuOpen}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleMenuClose}
        color="primary"
      >
        {optionsMenu.map((option) => (
          <MenuItem
            className={classes.menuItem}
            key={option.value}
            onClick={() => handleMenuClose(option.value, template)}
          >
            {option.icon}
            <span className={classes.menuItemText}>{option.label}</span>
          </MenuItem>
        ))}
      </Menu>
      <div className={classes.cardContent}>
        <div>
          <img src={docIcon} alt="iconDocTpl" className={classes.iconFile} />
        </div>
        <span variant="subtitle1" className={classes.title} title={fullName}>
          {fullName}
        </span>
      </div>
    </div>
  );
}
